<app-navbar></app-navbar>

<section class="pt-24 pb-20 xl:py-32 min-h-[50dvh] bg-white text-black">
    <div class="flex items-center justify-center mx-5 mb-10">
        <img src="src/assets/img/xlab_page/6835dcbfeec904106edc5899_xlab banner.png" alt="image" srcset="" class="w-full md:max-w-5xl h-auto mx-5 rounded-xl animate-fade-up animate-delay-100"/>
    </div>

    <div class="max-w-xl mx-auto px-4 text-center">
        <h1 class="text-4xl mb-5 animate-fade-up animate-delay-200">{{texts.title}}</h1>
        <p class="text-2xl mb-10 animate-fade-up animate-delay-300">{{texts.body}}</p>

        <div class="flex items-center justify-center mx-auto mb-10">
            <div class="flex">  
                <a href="https://www.facebook.com/profile.php?id=61577968478344" class="text-xl text-green-500 font-semibold hover:underline animate-fade-up animate-delay-500" target="_blank" rel="noopener noreferrer">
                    <img src="/src/assets/img/landing/672a22eeb26999ac92d064e6_icon_fb.svg" alt="Coming Soon" class="w-24 h-auto max-w-md mx-5" />
                </a>
                <a href="https://www.instagram.com/mundoev_cr?igsh=MThrd2V0ODByZzhuMQ==" class="text-xl text-green-500 font-semibold hover:underline animate-fade-up animate-delay-700" target="_blank" rel="noopener noreferrer">
                    <img src="/src/assets/img/landing/672a22e440553a7859cb75da_icon_ig.svg" alt="Coming Soon" class="w-24 h-auto max-w-md mx-5" />
                </a>
            </div>
        </div>
    </div>
</section>


<app-footer></app-footer>